import { render, staticRenderFns } from "./SettingCall.vue?vue&type=template&id=37846c9b&scoped=true&lang=pug&"
import script from "./SettingCall.vue?vue&type=script&lang=js&"
export * from "./SettingCall.vue?vue&type=script&lang=js&"
import style0 from "./SettingCall.vue?vue&type=style&index=0&id=37846c9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37846c9b",
  null
  
)

export default component.exports